import React, { useEffect, useRef, useState } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import './styles.scss'
import { scrollsize } from '../scrollheight'
gsap.registerPlugin(ScrollTrigger)

const Card = ({
  rotation,
  id,
  content
}: {
  rotation: number
  id: number
  content: contentElement | TitleElement
}) => {
  const section = useRef(null)
  useEffect(() => {
    window.onbeforeunload = function() {
      window.scrollTo(0, 0)
    }
  }, [])

  if (id > 1) {
    useEffect(() => {
      ScrollTrigger.create({
        trigger: section.current,
        start: 'center center',
        end: '+=' + String((id - 1) * scrollsize) + '%',
        pin: true,
        pinSpacing: false,
        pinType: 'fixed'
      })
    }, [])
  }

  return (
    <section
      ref={section}
      style={{
        transform: `rotate(` + rotation + `deg)`,
        zIndex: 5 - id
      }}
      className={'pin' + id}
      id={'pin' + id}
    >
      <CardComponent content={content} />
    </section>
  )
}

export default Card

const alphabet = 'aäbcdefghijklmnoöpqrstuüvwxyz'.split('')
const CardComponent = ({
  content
}: {
  content: contentElement | TitleElement
}) => {
  const {
    Vorname = '',
    Nachname = '',
    Bio = '',
    Rolle = '',
    Unternehmen = '',
    Funktion = '',
    Stapel = '',
    BildId = '',
    type = 'person'
  } = content
  const registerPos = Nachname
    ? (alphabet.indexOf(Nachname[0].toLocaleLowerCase()) * 75) / alphabet.length
    : 0

  let shownKeyValueCount = 0
  if (Unternehmen) shownKeyValueCount++
  if (Funktion) shownKeyValueCount++
  if (Rolle) shownKeyValueCount++

  const keyvals = [
    { k: 'Rôle dans le procès', v: Rolle, isSmall: true },
    { k: 'Entreprise', v: Unternehmen, isSmall: false },
    { k: 'Fonction', v: Funktion, isSmall: false }
  ]

  return (
    <div
      className={
        'CardComponent ' + Stapel + ' ' + (content.headline ? ' title' : '')
      }
    >
      {type === 'title' && (
        <>
          <div className='headline'>{(content as TitleElement).headline}</div>
          <div className='text '>{(content as TitleElement).text}</div>
        </>
      )}
      {type === 'person' && (
        <>
          <div
            className={'register ' + Stapel}
            style={{
              marginLeft: registerPos + '%'
            }}
          >
            {Nachname[0]}
          </div>

          <div className='name'>
            {Vorname} {Nachname}
          </div>
          {keyvals.map((m, index) => (
            <KeyValue key={index} {...m} />
          ))}

          <div className='bio'>
            {window.innerWidth > 600 && shownKeyValueCount < 3 && (
              <div
                className='placeholder'
                style={{
                  height: (3 - shownKeyValueCount) * 40 + 'px'
                }}
              />
            )}
            {Bio}
          </div>
          <div
            className='portrait'
            style={{
              transform:
                `rotate(` +
                Math.random() * 5 * (Math.round(Math.random()) ? 1 : -1) +
                `deg)`,

              backgroundImage: `url(${require('images/portraits/' +
                BildId +
                '.jpg')})`
            }}
          />
          <div className='klammer' />
        </>
      )}
    </div>
  )
}
const KeyValue = ({
  k,
  v,
  isSmall = false
}: {
  k: string
  v: string
  isSmall: boolean
}) => {
  if (!v) return null
  return (
    <div className={'keyvalue ' + (isSmall ? 'small' : '')}>
      <div className='key'>{k}</div> <div className='value'>{v}</div>
    </div>
  )
}
